import { createApp } from 'vue'
import options from './IndependentHeader.options'

const el = '.kb-component--independent-header'
const DOM = document.querySelector(el)

export default function (Store) {

    if(DOM){
        const template = DOM.innerHTML
        options.template = template
        const component = createApp(options).use(Store)
        component.mount(el)
    }
}

